/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralLookup } from '../../models/general-lookup';

export interface GetGeneralLookup_1$Params {
  generalLookupId: number;
}

export function getGeneralLookup_1(http: HttpClient, rootUrl: string, params: GetGeneralLookup_1$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
  const rb = new RequestBuilder(rootUrl, getGeneralLookup_1.PATH, 'get');
  if (params) {
    rb.path('generalLookupId', params.generalLookupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralLookup>;
    })
  );
}

getGeneralLookup_1.PATH = '/api/lookuptable/{generalLookupId}';
